module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/promo-d5c22fa4689ffcf3db872173e8102d93.png";